module.exports = __webpack_public_path__ + "images/last_point_arrived.13de625e91c0d75cf416b5bc650d503b.png";